import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Button,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import LocationApi from "../../services/Apis/Location.Api";
import { useCookies } from "react-cookie";

const initialValues = {
  store: "",
  location: "",
  complain: [],
  comment: "",
};

const ComplainForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [searchParam] = useSearchParams();
  const store = searchParam.get("store");
  const location = searchParam.get("location");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isFirstSubmit, setIsFirstSubmit] = useState(false);
  // For Cookie ..
  const [cookies, setCookie] = useCookies(["complaintSubmitted"]);
  const [submittedComplaints, setSubmittedComplaints] = useState([]);

  const formik = useFormik({
    initialValues: initialValues,
    // validationSchema: employeeLeaveFormValidationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  //  Create Tag   ...
  const { mutate: Complain, isLoading } = useMutation(
    (body) => {
      return LocationApi.createComplain(body);
    },
    {
      onSuccess: (res) => {
        if (res.success) {
          setIsSubmit(true);
          setIsFirstSubmit(true);

          // Saving Cookie .
          const updatedSubmittedComplaints = [
            ...submittedComplaints,
            { store, location },
          ];
          setSubmittedComplaints(updatedSubmittedComplaints);
          setCookie("complaintSubmitted", updatedSubmittedComplaints, {
            expires: new Date(Date.now() + 2 * 3600000),
          });
        } else {
          toast.error(res.message);
        }
      },
      onError: (error) => toast.error(error.message),
    }
  );

  // Cookie Checking ..
  useEffect(() => {
    if (cookies.complaintSubmitted) {
      const storedSubmittedComplaints = cookies.complaintSubmitted;
      const hasSubmitted = storedSubmittedComplaints.some(
        (complaint) =>
          complaint.store === store && complaint.location === location
      );
      setIsSubmit(hasSubmitted);
      setSubmittedComplaints(storedSubmittedComplaints);
    }
  }, [cookies.complaintSubmitted, store, location]);

  const handleSubmit = (values) => {
    Complain(values);
  };

  useEffect(() => {
    if (store && location) {
      formik.setFieldValue("store", store);
      formik.setFieldValue("location", location);
    }
  }, [store, location]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 40,
        marginLeft: 230,
        padding: isMobile ? 0 : "10px",
      }}
    >
      {!store || !location ? (
        <>
          <Typography variant="h5">
            Please scan QR Code again invalid information.
          </Typography>
        </>
      ) : (
        <>
          {isSubmit ? (
            <Grid>
              <Typography variant="h5">
                {isFirstSubmit
                  ? `Your complaint has been received and will be taken care asap.`
                  : `We already received your request and are working on it.`}
              </Typography>
            </Grid>
          ) : (
            <Card>
              <CardContent>
                {/* <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "20px",
                  }}
                ></Grid> */}
                <form onSubmit={formik.handleSubmit}>
                  {/* <Typography variant="h5">{store}</Typography> */}
                  <Typography variant="h5">{location}</Typography>
                  <FormControl component="fieldset">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.complain.includes("dirty")}
                            onChange={formik.handleChange}
                            name="complain"
                            value="dirty"
                          />
                        }
                        label="Dirty"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.complain.includes("leak")}
                            onChange={formik.handleChange}
                            name="complain"
                            value="leak"
                          />
                        }
                        label="Leak"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.complain.includes("broken")}
                            onChange={formik.handleChange}
                            name="complain"
                            value="broken"
                          />
                        }
                        label="Broken"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formik.values.complain.includes(
                              "noToiletPaper"
                            )}
                            onChange={formik.handleChange}
                            name="complain"
                            value="noToiletPaper"
                          />
                        }
                        label="No Toilet Paper"
                      />
                    </FormGroup>
                  </FormControl>
                  <TextField
                    label="Feed Back"
                    multiline
                    name="comment"
                    rows={4}
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    fullWidth
                    margin="normal"
                    error={
                      formik.touched.comment && Boolean(formik.errors.comment)
                    }
                    variant="outlined"
                    helperText={formik.touched.comment && formik.errors.comment}
                  />
                  <Button variant="contained" type="submit">
                    Submit
                  </Button>
                </form>
              </CardContent>
            </Card>
          )}
        </>
      )}
    </div>
  );
};

export default ComplainForm;
